// @flow
import BaseModel from 'Stores/BaseModel';
import AssetModel from 'Stores/AssetModel';

export default class EliteModel extends BaseModel {
  id: number = 0;
  sorting: number = 0;
  externalId: number = 0;
  hidden: boolean = false;
  offerType: string = 'SERVICE';
  priceInfo: string = '';
  price: string = '';
  headline1: string = '';
  headline2: string = '';
  copy: string = '';
  footnote: string = '';
  offerCategory: string = '';
  isOsbOffer: boolean = false;
  hasTireLabel: boolean = false;
  image: ?AssetModel = null;

  constructor(data: Object = {}) {
    super();
    this.hydrate(data);
    this.price = data.price ? data.price : '';
    this.offerCategory = data.offerCategory ? data.offerCategory : '';
    this.isOsbOffer = data.modalType === 'OSB';
  }
}
